/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React, {Suspense, useEffect, useRef, useState} from "react";
import {useDispatch} from "../useDispatch";
import {useTypedSelector} from "helpers/reducers";
import "assets/ExtraStyle.css";
import WithSuspenseLoader from "../components/WithSuspenseLoader";
import Popup from "pages/Front/components/Popup";
import SessionAction from "store/session/SessionAction";
import {useTranslation} from "react-i18next";
import BookingHeaderBreadcrumb from "pages/Front/Booking/components/BookingHeaderBreadcrumb";
import LogoNew from "pages/Front/components/LogoNew";
import BookingLoginButtonNew from "pages/Front/Booking/components/BookingLoginButtonNew";
import LanguageNew from "pages/Front/components/LanguageNew";
import clsx from "clsx";
// import HomeIcon from "@heroicons/react/24/outline/HomeIcon";

const CookieConsentComponent = React.lazy(() => import("react-cookie-consent"));
const CookieConsent = props => <WithSuspenseLoader>{<CookieConsentComponent {...props} />}</WithSuspenseLoader>;

interface UnloggedLayoutNewProps {
    children: React.ReactNode | React.ReactNode[];
}

const UnloggedLayoutNew = (props: UnloggedLayoutNewProps) => {
    const {t} = useTranslation();
    const scrollingRef = useRef<HTMLDivElement | null>(null);
    const dispatch = useDispatch();

    //if no language is set, use hall language
    const hallLanguage = useTypedSelector(state => state.hallState.hall?.language?.code);
    const language = useTypedSelector(state => state.sessionState).language?.code || hallLanguage;
    const [loginEnabled, setLoginEnabled] = useState<boolean>(true);

    useEffect(() => {
        if (language) {
            dispatch(SessionAction.setLanguage(language));
        }
    }, []);

    useEffect(() => {
        scrollingRef.current!.scrollTo(0, 0);
        window.scrollTo(0, 0);
    }, [location.pathname]);

    return (
        <Suspense fallback={<div>Loading...</div>}>
            <div className="UnloggedLayoutNew relative bg-white flex flex-grow">
                <div className={"UnloggedLayoutNewOuter w-full flex-grow flex flex-col justify-center z-2 relative"}>
                    <div className={"absolute top-0 left-0 right-0 z-[10]"}>
                        <div
                            className={
                                "relative flex items-center justify-between gap-2 sm:gap-4 lg:gap-2 xl:gap-6 z-[11] bg-white sm:bg-transparent shadow-lg sm:shadow-none rounded-bl-[20px] sm:rounded-bl-none rounded-br-[20px] sm:rounded-br-none pl-4 py-0.5 sm:px-0 sm:py-0"
                            }
                        >
                            <LogoNew />
                            <div
                                className={
                                    "relative self-center h-auto flex flex-row justify-center items-center gap-x-6 sm:min-h-[60px] py-[15px] px-[32px] sm:px-[35px] text-black z-30 sm:bg-white sm:rounded-bl-[20px] sm:rounded-tl-[20px] sm:shadow-lg"
                                }
                            >
                                <BookingLoginButtonNew />
                                <LanguageNew />
                            </div>
                        </div>
                    </div>
                    <div className={clsx("relative flex flex-col flex-grow w-full bg-gray-100 pt-[80px] md:pt-[166px]")}>
                        <div className="absolute inset-x-0 top-0 h-[360px] grow self-stretch">
                            <div className="absolute inset-0">
                                {/* mobil */}
                                <img src="/img/background/header-mobile.svg" alt="header-mobile" className="block sm:hidden w-full h-auto" />

                                <img
                                    src="/img/background/header-desktop.svg"
                                    alt="header-desktop"
                                    className="hidden sm:block absolute inset-0 w-full h-full object-cover object-[bottom_center] aspect-[auto_5120/760] select-none pointer-events-none"
                                />
                            </div>
                        </div>
                        {/*<div className="absolute inset-x-0 top-0 w-full flex flex-row grow shrink-0 overflow-x-visible overflow-y-visible items-stretch self-stretch justify-evenly">*/}
                        {/*    /!* Výrez / pás pre hlavičku *!/*/}
                        {/*    <div className="absolute w-full left-0 top-0 min-w-0 h-[360px] block flex-row">*/}
                        {/*        /!* Mobile verzia (ak chceš, nechaj takto) *!/*/}
                        {/*        <img src="/img/background/header-mobile.svg" alt="header-mobile" className="block sm:hidden w-full h-full object-cover" />*/}
                        {/*        <img*/}
                        {/*            width={5120}*/}
                        {/*            height={1300}*/}
                        {/*            src="/img/background/header-desktop.svg"*/}
                        {/*            alt="header-desktop"*/}
                        {/*            className="hidden sm:block h-full object-cover w-full object-[bottom_center] overflow-clip aspect-[auto_5120/1300]"*/}
                        {/*        />*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        <BookingHeaderBreadcrumb />
                        <div ref={scrollingRef} className={"UnloggedLayoutNewInner flex-grow flex flex-col"} role="document">
                            {/*must be block for ios devices */}
                            <div className={"block flex-col flex-grow m-auto justify-between w-full"}>{props.children}</div>
                        </div>
                    </div>
                </div>
                <Popup />
                <div className="ref"></div>
            </div>
        </Suspense>
    );
};
export default UnloggedLayoutNew;
